// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-8{
  inset: -2rem;
}
.inset-0{
  inset: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-left-1{
  left: -0.25rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-24{
  right: -6rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-5{
  top: -1.25rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-\\[72px\\]{
  bottom: 72px;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-8{
  right: 2rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-\\[84px\\]{
  top: 84px;
}
.top-full{
  top: 100%;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[-1\\]{
  z-index: -1;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-8{
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-8{
  margin-right: 2rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[-8px\\]{
  margin-top: -8px;
}
.mt-\\[2px\\]{
  margin-top: 2px;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[4\\/5\\]{
  aspect-ratio: 4/5;
}
.aspect-\\[9\\/16\\]{
  aspect-ratio: 9/16;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[176px\\]{
  height: 176px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[210px\\]{
  height: 210px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[260px\\]{
  height: 260px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[340px\\]{
  height: 340px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[4px\\]{
  height: 4px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[82vh\\]{
  height: 82vh;
}
.h-\\[86vh\\]{
  height: 86vh;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[330px\\]{
  max-height: 330px;
}
.max-h-\\[460px\\]{
  max-height: 460px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[620px\\]{
  max-height: 620px;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[78vh\\]{
  max-height: 78vh;
}
.max-h-\\[80\\%\\]{
  max-height: 80%;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[88\\%\\]{
  max-height: 88%;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[110px\\]{
  min-height: 110px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[124px\\]{
  min-height: 124px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[38px\\]{
  min-height: 38px;
}
.min-h-\\[390px\\]{
  min-height: 390px;
}
.min-h-\\[410px\\]{
  min-height: 410px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[560px\\]{
  min-height: 560px;
}
.min-h-\\[64px\\]{
  min-height: 64px;
}
.min-h-\\[92px\\]{
  min-height: 92px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[1040px\\]{
  width: 1040px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[210px\\]{
  width: 210px;
}
.w-\\[238px\\]{
  width: 238px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[4px\\]{
  width: 4px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[880px\\]{
  width: 880px;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-\\[980px\\]{
  width: 980px;
}
.w-\\[calc\\(100vw-2rem\\)\\]{
  width: calc(100vw - 2rem);
}
.w-\\[min\\(16rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\]{
  width: min(16rem,calc(100vw - 1.5rem));
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[1500px\\]{
  min-width: 1500px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[210px\\]{
  min-width: 210px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[310px\\]{
  max-width: 310px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[430px\\]{
  max-width: 430px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[880px\\]{
  max-width: 880px;
}
.max-w-\\[95vw\\]{
  max-width: 95vw;
}
.max-w-\\[980px\\]{
  max-width: 980px;
}
.max-w-\\[98vw\\]{
  max-width: 98vw;
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.origin-top{
  transform-origin: top;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[fadeIn_120ms_ease-out\\]{
  animation: fadeIn 120ms ease-out;
}
.animate-\\[notifbar_5s_linear_forwards\\]{
  animation: notifbar 5s linear forwards;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-crosshair{
  cursor: crosshair;
}
.cursor-default{
  cursor: default;
}
.cursor-none{
  cursor: none;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-wait{
  cursor: wait;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[minmax\\(0\\2c 1\\.1fr\\)_minmax\\(0\\2c 1\\.9fr\\)_auto\\]{
  grid-template-columns: minmax(0,1.1fr) minmax(0,1.9fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: minmax(0,1fr) auto;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-white\\/5 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.05);
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.justify-self-center{
  justify-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[22px\\]{
  border-radius: 22px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[34px\\]{
  border-radius: 34px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 12px;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-r-3xl{
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#23233a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(35 35 58 / var(--tw-border-opacity, 1));
}
.border-\\[\\#25254A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(37 37 74 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2563EB\\]\\/40{
  border-color: rgb(37 99 235 / 0.4);
}
.border-\\[\\#2A2A40\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 42 64 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2B2B4A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(43 43 74 / var(--tw-border-opacity, 1));
}
.border-\\[\\#30304d\\]{
  --tw-border-opacity: 1;
  border-color: rgb(48 48 77 / var(--tw-border-opacity, 1));
}
.border-\\[\\#343454\\]{
  --tw-border-opacity: 1;
  border-color: rgb(52 52 84 / var(--tw-border-opacity, 1));
}
.border-\\[\\#353550\\]{
  --tw-border-opacity: 1;
  border-color: rgb(53 53 80 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3A3A4A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(58 58 74 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3A3A50\\]{
  --tw-border-opacity: 1;
  border-color: rgb(58 58 80 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3a3a4d\\]{
  --tw-border-opacity: 1;
  border-color: rgb(58 58 77 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F59E0B33\\]{
  border-color: #F59E0B33;
}
.border-\\[\\#FC2783\\]{
  --tw-border-opacity: 1;
  border-color: rgb(252 39 131 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FC2783\\]\\/30{
  border-color: rgb(252 39 131 / 0.3);
}
.border-\\[\\#FC2783\\]\\/40{
  border-color: rgb(252 39 131 / 0.4);
}
.border-\\[\\#dbdde1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(219 221 225 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/40{
  border-color: rgb(251 191 36 / 0.4);
}
.border-amber-500\\/40{
  border-color: rgb(245 158 11 / 0.4);
}
.border-amber-600\\/40{
  border-color: rgb(217 119 6 / 0.4);
}
.border-amber-700\\/40{
  border-color: rgb(180 83 9 / 0.4);
}
.border-amber-700\\/50{
  border-color: rgb(180 83 9 / 0.5);
}
.border-blue-400\\/70{
  border-color: rgb(96 165 250 / 0.7);
}
.border-blue-500\\/40{
  border-color: rgb(59 130 246 / 0.4);
}
.border-emerald-400\\/25{
  border-color: rgb(52 211 153 / 0.25);
}
.border-emerald-400\\/40{
  border-color: rgb(52 211 153 / 0.4);
}
.border-emerald-500\\/40{
  border-color: rgb(16 185 129 / 0.4);
}
.border-emerald-500\\/70{
  border-color: rgb(16 185 129 / 0.7);
}
.border-emerald-600\\/40{
  border-color: rgb(5 150 105 / 0.4);
}
.border-emerald-700\\/40{
  border-color: rgb(4 120 87 / 0.4);
}
.border-emerald-700\\/50{
  border-color: rgb(4 120 87 / 0.5);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-indigo-600\\/40{
  border-color: rgb(79 70 229 / 0.4);
}
.border-pink-400{
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}
.border-pink-400\\/30{
  border-color: rgb(244 114 182 / 0.3);
}
.border-pink-400\\/60{
  border-color: rgb(244 114 182 / 0.6);
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.border-pink-500\\/25{
  border-color: rgb(236 72 153 / 0.25);
}
.border-pink-500\\/30{
  border-color: rgb(236 72 153 / 0.3);
}
.border-pink-500\\/40{
  border-color: rgb(236 72 153 / 0.4);
}
.border-pink-500\\/50{
  border-color: rgb(236 72 153 / 0.5);
}
.border-pink-500\\/60{
  border-color: rgb(236 72 153 / 0.6);
}
.border-pink-500\\/70{
  border-color: rgb(236 72 153 / 0.7);
}
.border-pink-600\\/40{
  border-color: rgb(219 39 119 / 0.4);
}
.border-pink-600\\/60{
  border-color: rgb(219 39 119 / 0.6);
}
.border-pink-600\\/70{
  border-color: rgb(219 39 119 / 0.7);
}
.border-pink-700{
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity, 1));
}
.border-pink-700\\/40{
  border-color: rgb(190 24 93 / 0.4);
}
.border-red-500\\/40{
  border-color: rgb(239 68 68 / 0.4);
}
.border-red-500\\/50{
  border-color: rgb(239 68 68 / 0.5);
}
.border-red-500\\/60{
  border-color: rgb(239 68 68 / 0.6);
}
.border-rose-500\\/40{
  border-color: rgb(244 63 94 / 0.4);
}
.border-rose-600\\/40{
  border-color: rgb(225 29 72 / 0.4);
}
.border-rose-700\\/40{
  border-color: rgb(190 18 60 / 0.4);
}
.border-rose-700\\/50{
  border-color: rgb(190 18 60 / 0.5);
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/30{
  border-color: rgb(234 179 8 / 0.3);
}
.border-yellow-500\\/40{
  border-color: rgb(234 179 8 / 0.4);
}
.border-yellow-500\\/60{
  border-color: rgb(234 179 8 / 0.6);
}
.border-zinc-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-zinc-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-zinc-700\\/50{
  border-color: rgb(63 63 70 / 0.5);
}
.border-zinc-700\\/60{
  border-color: rgb(63 63 70 / 0.6);
}
.border-zinc-700\\/70{
  border-color: rgb(63 63 70 / 0.7);
}
.border-zinc-800\\/60{
  border-color: rgb(39 39 42 / 0.6);
}
.border-zinc-800\\/70{
  border-color: rgb(39 39 42 / 0.7);
}
.bg-\\[\\#03030e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(3 3 14 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#050516\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(5 5 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#050516\\]\\/95{
  background-color: rgb(5 5 22 / 0.95);
}
.bg-\\[\\#070716\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(7 7 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#090918\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B0B18\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B0B19\\]\\/90{
  background-color: rgb(11 11 25 / 0.9);
}
.bg-\\[\\#0F0F1B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F0F1C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 28 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F0F21\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f0f20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f0f21\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f0f22\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#111124\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#111124\\]\\/95{
  background-color: rgb(17 17 36 / 0.95);
}
.bg-\\[\\#111827\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121226\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#141428\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#151528\\]\\/95{
  background-color: rgb(21 21 40 / 0.95);
}
.bg-\\[\\#151529\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 41 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#15152B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 43 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#15152B\\]\\/90{
  background-color: rgb(21 21 43 / 0.9);
}
.bg-\\[\\#171722\\]\\/95{
  background-color: rgb(23 23 34 / 0.95);
}
.bg-\\[\\#17172a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#181828\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#18182a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#191930\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(25 25 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#191930\\]\\/60{
  background-color: rgb(25 25 48 / 0.6);
}
.bg-\\[\\#1A1A31\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 49 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C1C2E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C1C34\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1D2A3F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 42 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E1E33\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1F1F2F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 47 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1F1F42\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 66 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1a30\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1b1b32\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 27 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c1c33\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1f2937\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#212134\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#21213a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#221b36\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 27 54 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22223a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#222246\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 70 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22c55e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#232336\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 54 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#23233a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#232344\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#252540\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#29294a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(41 41 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2A2A40\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2B2B4A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(43 43 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2a2a3f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2e2e45\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 69 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3b82f6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F82E88\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 46 136 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FC2783\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 39 131 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(248\\2c 46\\2c 136\\2c 1\\)\\]{
  background-color: rgba(248,46,136,1);
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-400\\/10{
  background-color: rgb(251 191 36 / 0.1);
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-600\\/15{
  background-color: rgb(217 119 6 / 0.15);
}
.bg-amber-900\\/30{
  background-color: rgb(120 53 15 / 0.3);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/25{
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/35{
  background-color: rgb(0 0 0 / 0.35);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/15{
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/20{
  background-color: rgb(37 99 235 / 0.2);
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/10{
  background-color: rgb(52 211 153 / 0.1);
}
.bg-emerald-400\\/80{
  background-color: rgb(52 211 153 / 0.8);
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15{
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/10{
  background-color: rgb(5 150 105 / 0.1);
}
.bg-emerald-600\\/15{
  background-color: rgb(5 150 105 / 0.15);
}
.bg-emerald-600\\/20{
  background-color: rgb(5 150 105 / 0.2);
}
.bg-emerald-700\\/50{
  background-color: rgb(4 120 87 / 0.5);
}
.bg-emerald-900\\/30{
  background-color: rgb(6 78 59 / 0.3);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600\\/15{
  background-color: rgb(79 70 229 / 0.15);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-pink-500\\/10{
  background-color: rgb(236 72 153 / 0.1);
}
.bg-pink-500\\/15{
  background-color: rgb(236 72 153 / 0.15);
}
.bg-pink-500\\/20{
  background-color: rgb(236 72 153 / 0.2);
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-pink-600\\/10{
  background-color: rgb(219 39 119 / 0.1);
}
.bg-pink-600\\/15{
  background-color: rgb(219 39 119 / 0.15);
}
.bg-pink-600\\/20{
  background-color: rgb(219 39 119 / 0.2);
}
.bg-pink-600\\/30{
  background-color: rgb(219 39 119 / 0.3);
}
.bg-pink-700\\/50{
  background-color: rgb(190 24 93 / 0.5);
}
.bg-pink-700\\/70{
  background-color: rgb(190 24 93 / 0.7);
}
.bg-pink-900\\/30{
  background-color: rgb(131 24 67 / 0.3);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/20{
  background-color: rgb(220 38 38 / 0.2);
}
.bg-rose-500\\/10{
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-600\\/15{
  background-color: rgb(225 29 72 / 0.15);
}
.bg-rose-600\\/20{
  background-color: rgb(225 29 72 / 0.2);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/0{
  background-color: rgb(255 255 255 / 0);
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.045\\]{
  background-color: rgb(255 255 255 / 0.045);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-yellow-500\\/10{
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/15{
  background-color: rgb(234 179 8 / 0.15);
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-zinc-800{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.bg-zinc-800\\/50{
  background-color: rgb(39 39 42 / 0.5);
}
.bg-zinc-800\\/60{
  background-color: rgb(39 39 42 / 0.6);
}
.bg-zinc-800\\/70{
  background-color: rgb(39 39 42 / 0.7);
}
.bg-zinc-800\\/80{
  background-color: rgb(39 39 42 / 0.8);
}
.bg-zinc-900{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900\\/40{
  background-color: rgb(24 24 27 / 0.4);
}
.bg-zinc-900\\/60{
  background-color: rgb(24 24 27 / 0.6);
}
.bg-zinc-900\\/70{
  background-color: rgb(24 24 27 / 0.7);
}
.bg-zinc-900\\/80{
  background-color: rgb(24 24 27 / 0.8);
}
.bg-zinc-900\\/90{
  background-color: rgb(24 24 27 / 0.9);
}
.bg-zinc-950\\/30{
  background-color: rgb(9 9 11 / 0.3);
}
.bg-zinc-950\\/40{
  background-color: rgb(9 9 11 / 0.4);
}
.bg-zinc-950\\/70{
  background-color: rgb(9 9 11 / 0.7);
}
.bg-zinc-950\\/80{
  background-color: rgb(9 9 11 / 0.8);
}
.bg-opacity-40{
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60{
  --tw-bg-opacity: 0.6;
}
.bg-opacity-70{
  --tw-bg-opacity: 0.7;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(248\\2c 46\\2c 136\\2c 0\\.16\\)_0\\%\\2c rgba\\(96\\2c 93\\2c 255\\2c 0\\.12\\)_50\\%\\2c rgba\\(245\\2c 158\\2c 11\\2c 0\\.14\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(248,46,136,0.16) 0%,rgba(96,93,255,0.12) 50%,rgba(245,158,11,0.14) 100%);
}
.bg-\\[radial-gradient\\(circle_at_top\\2c rgba\\(91\\2c 78\\2c 255\\2c 0\\.18\\)\\2c rgba\\(5\\2c 5\\2c 22\\2c 0\\.96\\)_48\\%\\)\\]{
  background-image: radial-gradient(circle at top,rgba(91,78,255,0.18),rgba(5,5,22,0.96) 48%);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#050516\\]{
  --tw-gradient-from: #050516 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 5 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0F0F1B\\]{
  --tw-gradient-from: #0F0F1B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 15 27 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1C1C2E\\]{
  --tw-gradient-from: #1C1C2E var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(28 28 46 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1f1f3a\\]{
  --tw-gradient-from: #1f1f3a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 31 58 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#5E72E4\\]{
  --tw-gradient-from: #5E72E4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 114 228 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#605DFF\\]{
  --tw-gradient-from: #605DFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 93 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F3123C\\]{
  --tw-gradient-from: #F3123C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 18 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FC2783\\]{
  --tw-gradient-from: #FC2783 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 39 131 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FC2783\\]\\/80{
  --tw-gradient-from: rgb(252 39 131 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 39 131 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/30{
  --tw-gradient-from: rgb(0 0 0 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600\\/20{
  --tw-gradient-from: rgb(219 39 119 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/5{
  --tw-gradient-from: rgb(255 255 255 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[30\\%\\]{
  --tw-gradient-from-position: 30%;
}
.via-\\[\\#121225\\]{
  --tw-gradient-to: rgb(18 18 37 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #121225 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FC2783\\]{
  --tw-gradient-to: rgb(252 39 131 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FC2783 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-fuchsia-600\\/10{
  --tw-gradient-to: rgb(192 38 211 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(192 38 211 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/10{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#050516\\]{
  --tw-gradient-to: #050516 var(--tw-gradient-to-position);
}
.to-\\[\\#15152B\\]{
  --tw-gradient-to: #15152B var(--tw-gradient-to-position);
}
.to-\\[\\#181828\\]{
  --tw-gradient-to: #181828 var(--tw-gradient-to-position);
}
.to-\\[\\#252538\\]{
  --tw-gradient-to: #252538 var(--tw-gradient-to-position);
}
.to-\\[\\#605DFF\\]{
  --tw-gradient-to: #605DFF var(--tw-gradient-to-position);
}
.to-\\[\\#9C27B0\\]{
  --tw-gradient-to: #9C27B0 var(--tw-gradient-to-position);
}
.to-\\[\\#9C27B0\\]\\/70{
  --tw-gradient-to: rgb(156 39 176 / 0.7) var(--tw-gradient-to-position);
}
.to-\\[\\#A855F7\\]{
  --tw-gradient-to: #A855F7 var(--tw-gradient-to-position);
}
.to-\\[\\#F97316\\]{
  --tw-gradient-to: #F97316 var(--tw-gradient-to-position);
}
.to-\\[\\#b2b2b2\\]{
  --tw-gradient-to: #b2b2b2 var(--tw-gradient-to-position);
}
.to-pink-200{
  --tw-gradient-to: #fbcfe8 var(--tw-gradient-to-position);
}
.to-pink-300{
  --tw-gradient-to: #f9a8d4 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white\\/5{
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}
.bg-clip-border{
  background-clip: border-box;
}
.bg-clip-text{
  background-clip: text;
}
.fill-black\\/90{
  fill: rgb(0 0 0 / 0.9);
}
.fill-yellow-400{
  fill: #facc15;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-top{
  object-position: top;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-32{
  padding-bottom: 8rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-44{
  padding-bottom: 11rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: Inter, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[38px\\]{
  font-size: 38px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.07\\]{
  line-height: 1.07;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.22em\\]{
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-\\[\\#050514\\]{
  --tw-text-opacity: 1;
  color: rgb(5 5 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22c55e\\]{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4318FF\\]{
  --tw-text-opacity: 1;
  color: rgb(67 24 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4ade80\\]{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#60A5FA\\]{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F97373\\]{
  --tw-text-opacity: 1;
  color: rgb(249 115 115 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FC2783\\]{
  --tw-text-opacity: 1;
  color: rgb(252 39 131 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f87171\\]{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f97316\\]{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f97373\\]{
  --tw-text-opacity: 1;
  color: rgb(249 115 115 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fbbf24\\]{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-100\\/90{
  color: rgb(254 243 199 / 0.9);
}
.text-amber-200{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.text-amber-200\\/95{
  color: rgb(253 230 138 / 0.95);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-emerald-100{
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-200\\/90{
  color: rgb(229 231 235 / 0.9);
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-indigo-200{
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-inherit{
  color: inherit;
}
.text-pink-100{
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity, 1));
}
.text-pink-200{
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity, 1));
}
.text-pink-300{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.text-pink-300\\/80{
  color: rgb(249 168 212 / 0.8);
}
.text-pink-300\\/85{
  color: rgb(249 168 212 / 0.85);
}
.text-pink-400{
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-pink-400\\/80{
  color: rgb(244 114 182 / 0.8);
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-rose-200{
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.text-rose-300{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-200\\/90{
  color: rgb(226 232 240 / 0.9);
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/45{
  color: rgb(255 255 255 / 0.45);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-white\\/95{
  color: rgb(255 255 255 / 0.95);
}
.text-yellow-200{
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-zinc-100{
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}
.text-zinc-200{
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity, 1));
}
.text-zinc-300{
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.text-zinc-400{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.text-zinc-800{
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
}
.text-zinc-900{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.decoration-pink-400{
  text-decoration-color: #f472b6;
}
.decoration-pink-500\\/60{
  text-decoration-color: rgb(236 72 153 / 0.6);
}
.decoration-white\\/60{
  text-decoration-color: rgb(255 255 255 / 0.6);
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.accent-pink-500{
  accent-color: #ec4899;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-95{
  opacity: 0.95;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgba\\(252\\2c 39\\2c 131\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(252,39,131,0.35);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(255,255,255,0.05);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_14px_rgba\\(248\\2c 46\\2c 136\\2c 1\\)\\]{
  --tw-shadow: 0 0 14px rgba(248,46,136,1);
  --tw-shadow-colored: 0 0 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_60px_rgba\\(252\\2c 39\\2c 131\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 0 60px rgba(252,39,131,0.25);
  --tw-shadow-colored: 0 0 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_60px_rgba\\(252\\2c 39\\2c 131\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 0 60px rgba(252,39,131,0.35);
  --tw-shadow-colored: 0 0 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_24px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 10px 24px rgba(34,197,94,0.45);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_26px_rgba\\(248\\2c 46\\2c 136\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 10px 26px rgba(248,46,136,0.35);
  --tw-shadow-colored: 0 10px 26px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_30px_rgba\\(248\\2c 46\\2c 136\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 12px 30px rgba(248,46,136,0.45);
  --tw-shadow-colored: 0 12px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 14px 30px rgba(0,0,0,0.55);
  --tw-shadow-colored: 0 14px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_32px_rgba\\(96\\2c 93\\2c 255\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 14px 32px rgba(96,93,255,0.5);
  --tw-shadow-colored: 0 14px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_34px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 14px 34px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 14px 34px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_34px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\]{
  --tw-shadow: 0 14px 34px rgba(0,0,0,0.65);
  --tw-shadow-colored: 0 14px 34px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_34px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 16px 34px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 16px 34px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 16px 40px rgba(0,0,0,0.55);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\]{
  --tw-shadow: 0 16px 40px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(248\\2c 46\\2c 136\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 16px 40px rgba(248,46,136,0.55);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_40px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 18px 40px rgba(15,23,42,0.55);
  --tw-shadow-colored: 0 18px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_44px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.60\\)\\]{
  --tw-shadow: 0 18px 44px rgba(0,0,0,0.60);
  --tw-shadow-colored: 0 18px 44px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_45px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.75\\)\\]{
  --tw-shadow: 0 18px 45px rgba(0,0,0,0.75);
  --tw-shadow-colored: 0 18px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_56px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.62\\)\\]{
  --tw-shadow: 0 20px 56px rgba(0,0,0,0.62);
  --tw-shadow-colored: 0 20px 56px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.75\\)\\]{
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.75);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_22px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.85\\)\\]{
  --tw-shadow: 0 22px 50px rgba(0,0,0,0.85);
  --tw-shadow-colored: 0 22px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_22px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\]{
  --tw-shadow: 0 22px 60px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 22px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.75\\)\\]{
  --tw-shadow: 0 24px 60px rgba(0,0,0,0.75);
  --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\]{
  --tw-shadow: 0 24px 60px rgba(0,0,0,0.9);
  --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.65\\)\\]{
  --tw-shadow: 0 24px 60px rgba(15,23,42,0.65);
  --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_75px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.82\\)\\]{
  --tw-shadow: 0 28px 75px rgba(0,0,0,0.82);
  --tw-shadow-colored: 0 28px 75px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_16px_0_rgba\\(252\\2c 39\\2c 131\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 2px 16px 0 rgba(252,39,131,0.08);
  --tw-shadow-colored: 0 2px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\]{
  --tw-shadow: 0 30px 80px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 30px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_90px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.78\\)\\]{
  --tw-shadow: 0 30px 90px rgba(0,0,0,0.78);
  --tw-shadow-colored: 0 30px 90px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_18px_rgba\\(248\\2c 46\\2c 136\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 8px 18px rgba(248,46,136,0.5);
  --tw-shadow-colored: 0 8px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_22px_rgba\\(248\\2c 46\\2c 136\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 8px 22px rgba(248,46,136,0.6);
  --tw-shadow-colored: 0 8px 22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.02\\)\\]{
  --tw-shadow: inset 0 0 0 1px rgba(255,255,255,0.02);
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.04\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.04);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.05\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.05);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/30{
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/40{
  --tw-shadow-color: rgb(0 0 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#2A2A40\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(42 42 64 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#FC2783\\]\\/70{
  --tw-ring-color: rgb(252 39 131 / 0.7);
}
.ring-pink-400\\/30{
  --tw-ring-color: rgb(244 114 182 / 0.3);
}
.ring-pink-500\\/40{
  --tw-ring-color: rgb(236 72 153 / 0.4);
}
.ring-pink-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 39 119 / var(--tw-ring-opacity, 1));
}
.ring-white\\/5{
  --tw-ring-color: rgb(255 255 255 / 0.05);
}
.ring-white\\/50{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-auto{
  will-change: auto;
}
.will-change-transform{
  will-change: transform;
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(220px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(220px,1fr));
}

body {
  font-family: 'Inter', sans-serif;
  background-color: #f9fafb;
  color: #1f2937;
}

/* index.css — existing utility badge (your app's own badge) */
.badge{
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

/* ========================= */
/* Clerk UI overrides        */
/* ========================= */

/* Make the outer Clerk wrapper always use full width of its container */
.cl-rootBox {
  width: 100% !important;
}

/* Make the Clerk auth card wider, like PagePilot */
.cl-card {
  width: 100% !important;
  max-width: 640px !important; /* tweak to 600px if you prefer */
}

/* Hide the small "Last used" badge above social buttons */
.cl-badge {
  display: none !important;
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-zinc-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.focus-within\\:border-\\[\\#FC2783\\]:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(252 39 131 / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-\\[\\#FC2783\\]:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 39 131 / var(--tw-ring-opacity, 1));
}
.hover\\:-translate-x-\\[2px\\]:hover{
  --tw-translate-x: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-\\[1px\\]:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-y-\\[-1px\\]:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-y-\\[-2px\\]:hover{
  --tw-translate-y: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.03\\]:hover{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#3A3A50\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(58 58 80 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#FC2783\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 39 131 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-500\\/60:hover{
  border-color: rgb(245 158 11 / 0.6);
}
.hover\\:border-emerald-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.hover\\:border-pink-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}
.hover\\:border-pink-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.hover\\:border-pink-500\\/30:hover{
  border-color: rgb(236 72 153 / 0.3);
}
.hover\\:border-pink-500\\/40:hover{
  border-color: rgb(236 72 153 / 0.4);
}
.hover\\:border-pink-500\\/50:hover{
  border-color: rgb(236 72 153 / 0.5);
}
.hover\\:border-pink-500\\/70:hover{
  border-color: rgb(236 72 153 / 0.7);
}
.hover\\:border-pink-600\\/60:hover{
  border-color: rgb(219 39 119 / 0.6);
}
.hover\\:border-rose-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.hover\\:border-white\\/15:hover{
  border-color: rgb(255 255 255 / 0.15);
}
.hover\\:border-zinc-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#20203a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 58 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#222246\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 70 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#232340\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 64 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2A2A40\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 64 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2A2A40\\]\\/60:hover{
  background-color: rgb(42 42 64 / 0.6);
}
.hover\\:bg-\\[\\#2B2B4A\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(43 43 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2a2a3f\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 63 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2c2c3e\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(44 44 62 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2d2d45\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(45 45 69 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2e2e45\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 69 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#363662\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(54 54 98 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#3D3D6E\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(61 61 110 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/80:hover{
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-black\\/85:hover{
  background-color: rgb(0 0 0 / 0.85);
}
.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-600\\/30:hover{
  background-color: rgb(5 150 105 / 0.3);
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-600\\/30:hover{
  background-color: rgb(219 39 119 / 0.3);
}
.hover\\:bg-pink-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-800\\/10:hover{
  background-color: rgb(157 23 77 / 0.1);
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600\\/30:hover{
  background-color: rgb(220 38 38 / 0.3);
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-600\\/20:hover{
  background-color: rgb(225 29 72 / 0.2);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:text-\\[\\#FC2783\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(252 39 131 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-100:hover{
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-200:hover{
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-300:hover{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-500:hover{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.hover\\:text-pink-600:hover{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-300:hover{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-zinc-100:hover{
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:decoration-white:hover{
  text-decoration-color: #fff;
}
.hover\\:shadow-\\[0_0_0_1px_rgba\\(252\\2c 39\\2c 131\\2c 0\\.7\\)\\2c 0_22px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.85\\)\\]:hover{
  --tw-shadow: 0 0 0 1px rgba(252,39,131,0.7),0 22px 50px rgba(0,0,0,0.85);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color), 0 22px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_12px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\]:hover{
  --tw-shadow: 0 12px 32px rgba(0,0,0,0.65);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_4px_24px_0_rgba\\(252\\2c 39\\2c 131\\2c 0\\.20\\)\\]:hover{
  --tw-shadow: 0 4px 24px 0 rgba(252,39,131,0.20);
  --tw-shadow-colored: 0 4px 24px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-glow:hover{
  --tw-shadow: 0 0 8px rgba(252, 39, 131, 0.5);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-glow:hover{
  --tw-shadow-color: rgba(252, 39, 131, 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-pink-500\\/40:hover{
  --tw-shadow-color: rgb(236 72 153 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-1:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-pink-500\\/30:hover{
  --tw-ring-color: rgb(236 72 153 / 0.3);
}
.hover\\:ring-pink-500\\/40:hover{
  --tw-ring-color: rgb(236 72 153 / 0.4);
}
.hover\\:brightness-105:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-110:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:drop-shadow-\\[0_0_10px_rgba\\(255\\2c 0\\2c 128\\2c 0\\.5\\)\\]:hover{
  --tw-drop-shadow: drop-shadow(0 0 10px rgba(255,0,128,0.5));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:drop-shadow-\\[0_0_10px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.45\\)\\]:hover{
  --tw-drop-shadow: drop-shadow(0 0 10px rgba(37,99,235,0.45));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:drop-shadow-\\[0_0_8px_rgba\\(252\\2c 39\\2c 131\\2c 0\\.25\\)\\]:hover{
  --tw-drop-shadow: drop-shadow(0 0 8px rgba(252,39,131,0.25));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-\\[\\#4318FF\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(67 24 255 / var(--tw-border-opacity, 1));
}
.focus\\:border-pink-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}
.focus\\:border-pink-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.focus\\:border-pink-500\\/60:focus{
  border-color: rgb(236 72 153 / 0.6);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-pink-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-500\\/40:focus{
  --tw-ring-color: rgb(236 72 153 / 0.4);
}
.focus\\:ring-pink-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 39 119 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-\\[\\#FC2783\\]\\/40:focus-visible{
  --tw-ring-color: rgb(252 39 131 / 0.4);
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-80:disabled{
  opacity: 0.8;
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-\\[2px\\]{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}
.group:hover .group-hover\\:bg-black\\/65{
  background-color: rgb(0 0 0 / 0.65);
}
.group:hover .group-hover\\:bg-pink-600\\/10{
  background-color: rgb(219 39 119 / 0.1);
}
.group:hover .group-hover\\:tracking-tight{
  letter-spacing: -0.025em;
}
.group:hover .group-hover\\:opacity-0{
  opacity: 0;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-70{
  opacity: 0.7;
}
.group:hover .group-hover\\:opacity-80{
  opacity: 0.8;
}
.group:hover .group-hover\\:opacity-85{
  opacity: 0.85;
}
@media (min-width: 640px){
  .sm\\:right-6{
    right: 1.5rem;
  }
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:mb-8{
    margin-bottom: 2rem;
  }
  .sm\\:mt-6{
    margin-top: 1.5rem;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:aspect-\\[4\\/3\\]{
    aspect-ratio: 4/3;
  }
  .sm\\:h-11{
    height: 2.75rem;
  }
  .sm\\:h-8{
    height: 2rem;
  }
  .sm\\:h-9{
    height: 2.25rem;
  }
  .sm\\:h-\\[300px\\]{
    height: 300px;
  }
  .sm\\:h-\\[320px\\]{
    height: 320px;
  }
  .sm\\:w-11{
    width: 2.75rem;
  }
  .sm\\:w-24{
    width: 6rem;
  }
  .sm\\:w-28{
    width: 7rem;
  }
  .sm\\:w-40{
    width: 10rem;
  }
  .sm\\:w-64{
    width: 16rem;
  }
  .sm\\:w-72{
    width: 18rem;
  }
  .sm\\:w-8{
    width: 2rem;
  }
  .sm\\:w-9{
    width: 2.25rem;
  }
  .sm\\:w-\\[280px\\]{
    width: 280px;
  }
  .sm\\:w-\\[300px\\]{
    width: 300px;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:max-w-\\[36rem\\]{
    max-width: 36rem;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-\\[1fr\\2c 1\\.4fr\\2c auto\\]{
    grid-template-columns: 1fr 1.4fr auto;
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-center{
    justify-content: center;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-2{
    gap: 0.5rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-6{
    gap: 1.5rem;
  }
  .sm\\:space-y-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
  }
  .sm\\:p-3{
    padding: 0.75rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:p-7{
    padding: 1.75rem;
  }
  .sm\\:p-8{
    padding: 2rem;
  }
  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .sm\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .sm\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .sm\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:pb-5{
    padding-bottom: 1.25rem;
  }
  .sm\\:pt-10{
    padding-top: 2.5rem;
  }
  .sm\\:pt-16{
    padding-top: 4rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-\\[0\\.95rem\\]{
    font-size: 0.95rem;
  }
  .sm\\:text-\\[14px\\]{
    font-size: 14px;
  }
  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }
  .sm\\:text-\\[2\\.5rem\\]{
    font-size: 2.5rem;
  }
  .sm\\:text-\\[50px\\]{
    font-size: 50px;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 768px){
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-8{
    height: 2rem;
  }
  .md\\:h-\\[170px\\]{
    height: 170px;
  }
  .md\\:h-\\[260px\\]{
    height: 260px;
  }
  .md\\:min-h-\\[72px\\]{
    min-height: 72px;
  }
  .md\\:w-28{
    width: 7rem;
  }
  .md\\:w-8{
    width: 2rem;
  }
  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }
  .md\\:w-\\[44\\%\\]{
    width: 44%;
  }
  .md\\:max-w-lg{
    max-width: 32rem;
  }
  .md\\:flex-1{
    flex: 1 1;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-\\[1\\.2fr\\2c 1fr\\2c 1fr\\2c 1fr\\]{
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
  }
  .md\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }
  .md\\:grid-cols-\\[minmax\\(0\\2c 2fr\\)_auto\\]{
    grid-template-columns: minmax(0,2fr) auto;
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-start{
    justify-content: flex-start;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:gap-7{
    gap: 1.75rem;
  }
  .md\\:rounded-none{
    border-radius: 0px;
  }
  .md\\:p-7{
    padding: 1.75rem;
  }
  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .md\\:pl-\\[260px\\]{
    padding-left: 260px;
  }
  .md\\:text-left{
    text-align: left;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-\\[0\\.95rem\\]{
    font-size: 0.95rem;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .lg\\:grid{
    display: grid;
  }
  .lg\\:w-32{
    width: 8rem;
  }
  .lg\\:w-\\[160px\\]{
    width: 160px;
  }
  .lg\\:w-\\[40\\%\\]{
    width: 40%;
  }
  .lg\\:max-w-\\[520px\\]{
    max-width: 520px;
  }
  .lg\\:max-w-\\[560px\\]{
    max-width: 560px;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[0\\.9fr\\2c 1\\.1fr\\]{
    grid-template-columns: 0.9fr 1.1fr;
  }
  .lg\\:grid-cols-\\[1fr_160px_1fr_auto\\]{
    grid-template-columns: 1fr 160px 1fr auto;
  }
  .lg\\:grid-cols-\\[1fr_400px\\]{
    grid-template-columns: 1fr 400px;
  }
  .lg\\:grid-cols-\\[auto_280px\\]{
    grid-template-columns: auto 280px;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-end{
    justify-content: flex-end;
  }
  .lg\\:justify-center{
    justify-content: center;
  }
  .lg\\:gap-4{
    gap: 1rem;
  }
  .lg\\:justify-self-end{
    justify-self: end;
  }
  .lg\\:p-10{
    padding: 2.5rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:text-left{
    text-align: left;
  }
  .lg\\:text-\\[2\\.6rem\\]{
    font-size: 2.6rem;
  }
  .lg\\:text-\\[2\\.75rem\\]{
    font-size: 2.75rem;
  }
  .lg\\:text-\\[54px\\]{
    font-size: 54px;
  }
}
@media (min-width: 1280px){
  .xl\\:w-36{
    width: 9rem;
  }
  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8DAA8D;AAE5D;EAAA,uBAAyE;EAAzE,kBAAyE;EAAzE,4DAAyE;EAAzE,oBAAyE;EAAzE,qBAAyE;EAAzE,oBAAyE;EAAzE,uBAAyE;EAAzE,kBAAyE;EAAzE,iBAAyE;EAAzE,gBAAyE;EAAzE,oBAAyE;EAAzE;AAAyE;;AAG3E,8BAA8B;AAC9B,8BAA8B;AAC9B,8BAA8B;;AAE9B,wEAAwE;AACxE;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,sBAAsB;EACtB,2BAA2B,EAAE,iCAAiC;AAChE;;AAEA,0DAA0D;AAC1D;EACE,wBAAwB;AAC1B;AAlCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,0BAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,wEAmCA;EAnCA,yFAmCA;EAnCA;AAmCA;AAnCA;EAAA,yCAmCA;EAnCA,uDAmCA;EAnCA;AAmCA;AAnCA;EAAA,+CAmCA;EAnCA,wDAmCA;EAnCA;AAmCA;AAnCA;EAAA,4CAmCA;EAnCA,mDAmCA;EAnCA;AAmCA;AAnCA;EAAA,+EAmCA;EAnCA,mGAmCA;EAnCA;AAmCA;AAnCA;EAAA,gFAmCA;EAnCA,oGAmCA;EAnCA;AAmCA;AAnCA;EAAA,2CAmCA;EAnCA;AAmCA;AAnCA;EAAA,wCAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,iCAmCA;EAnCA;AAmCA;AAnCA;EAAA,gCAmCA;EAnCA;AAmCA;AAnCA;EAAA,2DAmCA;EAnCA;AAmCA;AAnCA;EAAA,4DAmCA;EAnCA;AAmCA;AAnCA;EAAA,4DAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA,sBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,8BAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,oBAmCA;EAnCA;AAmCA;AAnCA;EAAA,8BAmCA;EAnCA;AAmCA;AAnCA;EAAA,2GAmCA;EAnCA,yGAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA,0BAmCA;EAnCA;AAmCA;AAnCA;EAAA,qBAmCA;EAnCA;AAmCA;AAnCA;EAAA,kBAmCA;EAnCA,kBAmCA;EAnCA;AAmCA;AAnCA;EAAA,iBAmCA;EAnCA,iBAmCA;EAnCA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;AAmCA;AAnCA;EAAA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,uBAmCA;IAnCA,+DAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,qBAmCA;IAnCA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA,qBAmCA;IAnCA;EAmCA;EAnCA;IAAA,oBAmCA;IAnCA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;EAnCA;IAAA,iBAmCA;IAnCA;EAmCA;EAnCA;IAAA,qBAmCA;IAnCA;EAmCA;EAnCA;IAAA,iBAmCA;IAnCA;EAmCA;EAnCA;IAAA,oBAmCA;IAnCA;EAmCA;EAnCA;IAAA,oBAmCA;IAnCA;EAmCA;EAnCA;IAAA,iBAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,iBAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA,eAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,eAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;AAAA;AAnCA;EAAA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA,gBAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,eAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;EAnCA;IAAA,mBAmCA;IAnCA;EAmCA;AAAA;AAnCA;EAAA;IAAA;EAmCA;EAnCA;IAAA,gBAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA,kBAmCA;IAnCA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;AAAA;AAnCA;EAAA;IAAA;EAmCA;EAnCA;IAAA;EAmCA;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background-color: #f9fafb;\n  color: #1f2937;\n}\n\n/* index.css — existing utility badge (your app's own badge) */\n.badge {\n  @apply bg-gray-100 text-gray-700 text-xs font-medium px-2 py-1 rounded-md;\n}\n\n/* ========================= */\n/* Clerk UI overrides        */\n/* ========================= */\n\n/* Make the outer Clerk wrapper always use full width of its container */\n.cl-rootBox {\n  width: 100% !important;\n}\n\n/* Make the Clerk auth card wider, like PagePilot */\n.cl-card {\n  width: 100% !important;\n  max-width: 640px !important; /* tweak to 600px if you prefer */\n}\n\n/* Hide the small \"Last used\" badge above social buttons */\n.cl-badge {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
